import { render, staticRenderFns } from "./RecoverableItemSizeTooltip.vue?vue&type=template&id=564cf463"
import script from "./RecoverableItemSizeTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecoverableItemSizeTooltip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports